import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[shAutoFocus]',
    standalone: true
})
export class ShAutoFocusDirective implements AfterViewInit {
    @Input('shAutoFocus') shouldFocus: boolean = false;

    constructor(private readonly el: ElementRef) {}

    ngAfterViewInit() {
        if (this.shouldFocus) {
            // wait until the DOM settles
            setTimeout(() => this.el.nativeElement.focus());
        }
    }
}
